import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Divider } from "antd";
import { getStyleProperties } from "../../utils/CustomFunc";
import PerformanceGaugeGraph from "./Graph/PerformanceGaugeGraph";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { useDispatch, useSelector } from "react-redux";

const LineDashTabLeft = ({
  lid,
  settings,
  Actual,
  settingValues,
  Diff,
  Rank,
  Target,
  mainG,
  dBlock,
  mini,
}) => {
  const LeftCol = {
    backgroundColor: "#FF33CC",
    padding: "10px 5px",
    border: "1px solid #cc99AA",
  };

  const dispatch = useDispatch();

  const [leftContainer, setLeftContainer] = useState(null);
  const [v, setV] = useState(null);
  // const [target, setTarget] = useState(Target);
  // const [actual, setActual] = useState(Actual);
  // const [diff, setDiff] = useState(Diff);
  // const [rank, setRank] = useState(Rank);

  const [text1, setText1] = useState(null);
  const [text2, setText2] = useState(null);
  const [text3, setText3] = useState(null);

  const [loginError, setLoginError] = useState(false);
  const [img, setImg] = useState(null);

  const refresh = useSelector((state) => state.refresh);

  useEffect(() => {
    let interval = setInterval(() => {
      liracrypt
        .get("/cp/singleline", { lid: lid, pid: "pid_011" })
        .then(({ data }) => {
          // dispatch({ type: "SET_LINE_IMG", payload: data.data["pid_011"] });

          liracrypt
            .get("/imagecontrol", { _id: data.data["pid_011"] })
            .then((res, req) => {
              // console.log(res.data.data, data.data["pid_011"]);
              if (res.data.data) {
                setImg(res.data.data);
              }
            })
            .catch((error) => {
              console.log("Error****:", error);
            });
        })
        .catch(function (error) {
          console.log("Error****:", error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }, 60000);
    return (() => clearInterval(interval))
  }, [refresh]);

  useEffect(() => {
    // if (settings && settingValues) {
    // console.log("LC");
    let microGraph = [];
    for (let i = 0; i < parseInt(settings.ld_main.microGuageQty); i++) {
      const key =
        i < 10 ? "ld_MicroGauge_0" + (i + 1) : "ld_MicroGauge_" + (i + 1);
      const settingKey =
        i < 10 ? "lD_MicroGauge_0" + (i + 1) : "lD_MicroGauge_" + (i + 1);
      if (settings.hasOwnProperty(key)) {
        microGraph.push({
          text: settings[key].text,
          text_style: getStyleProperties({ ...settings[key].legend }),
          value:
            (settingValues[settingKey] != null ||
              settingValues[settingKey] != undefined) &&
              settingValues[settingKey].toString().indexOf("%") >= 0
              ? settingValues[settingKey].substr(
                0,
                settingValues[settingKey].indexOf("%")
              )
              : settingValues[settingKey],
          value_style: getStyleProperties(settings[key].data),
          graphColor: settings[key].axes,
          numbeOfGraph: settings.ld_main.microGuageQty,
          backgroundColor: settings[key]["background-color"],
        });
      }
    }
    let contentSettings = {
      performance: {
        title: {
          text: settings.ld_ShiftPerf_Main.text,
          style: getStyleProperties({
            ...settings.ld_ShiftPerf_Main.legend,
          }),
        },
        backgroundColor: settings.ld_ShiftPerf_Main["background-color"],
        target: {
          text: settings.ld_ShiftPerf_Tgt.text,
          text_style: getStyleProperties(settings.ld_ShiftPerf_Tgt.legend),
          value: settingValues.lD_ShiftPerf_Tgt,
          value_style: getStyleProperties(settings.ld_ShiftPerf_Tgt.data),
        },
        actual: {
          text: settings.ld_ShiftPerf_Actual.text,
          text_style: getStyleProperties(settings.ld_ShiftPerf_Actual.legend),
          value: settingValues.lD_ShiftPerf_Actual,
          value_style: getStyleProperties(settings.ld_ShiftPerf_Actual.data),
        },
        difference: {
          text: settings.ld_ShiftPerf_Diff.text,
          text_style: getStyleProperties(settings.ld_ShiftPerf_Diff.legend),
          value: settingValues.lD_ShiftPerf_Diff,
          value_style: getStyleProperties(settings.ld_ShiftPerf_Diff.data),
        },
        linerank: {
          text: settings.ld_LineRank_Main.text,
          text_style: getStyleProperties(settings.ld_LineRank_Main.legend),
          value: settingValues.lD_LineRank_Main,
          value_style: getStyleProperties(settings.ld_LineRank_Main.data),
        },
      },
      parts: {
        title: {
          text: settings.ld_PartDet_Main.text,
          style: getStyleProperties({
            ...settings.ld_PartDet_Main.legend,
          }),
        },
        backgroundColor: settings.ld_PartDet_Main["background-color"],
        // image: {
        //   src: settingValues.lD_PartDet_Img,
        // },
        product_no: {
          // text: settings.LD_PartDet_Pno.Text,
          // text_style: getStyleProperties(settings.LD_LineRank_Main.legend),
          value: settingValues.lD_PartDet_pno,
          value_style: getStyleProperties(settings.ld_PartDet_Pno.data),
        },
        product_name: {
          // text: settings.LD_PartDet_Pno.Text,
          // text_style: getStyleProperties(settings.LD_LineRank_Main.legend),
          value: settingValues.lD_PartDet_Pname,
          value_style: getStyleProperties(settings.ld_PartDet_Pname.data),
        },
        customer: {
          // text: settings.LD_PartDet_Pno.Text,
          // text_style: getStyleProperties(settings.LD_LineRank_Main.legend),
          value: settingValues.lD_PartDet_Cust,
          value_style: getStyleProperties(settings.ld_PartDet_Cust.data),
        },
      },
      mainGraph: {
        text: settings["ld_MainGauge"].text,
        text_style: getStyleProperties({
          ...settings.ld_MainGauge.legend,
        }),
        value:
          (settingValues["lD_MainGauge"] != null ||
            settingValues["lD_MainGauge"] != undefined) &&
            settingValues["lD_MainGauge"].toString().indexOf("%") >= 0
            ? settingValues["lD_MainGauge"].substr(
              0,
              settingValues["lD_MainGauge"].indexOf("%")
            )
            : settingValues["lD_MainGauge"],
        value_style: getStyleProperties(settings.ld_MainGauge.data),
        graphColor: settings.ld_MainGauge.axes,
        numbeOfGraph: 1,
        backgroundColor: settings.ld_MainGauge["background-color"],
      },
      microGraph: microGraph,
    };
    setLeftContainer(contentSettings);
    // setTarget(contentSettings.performance.target.value);
    // setActual(contentSettings.performance.actual.value);
    // setDiff(contentSettings.performance.difference.value);
    // setRank(contentSettings.performance.linerank.value);
    setText1(contentSettings.parts.product_no.value);
    setText2(contentSettings.parts.product_name.value);
    setText3(contentSettings.parts.customer.value);

    // console.log(Target, Diff, Actual, Rank);
  }, [settingValues]);

  const ImageV = () => {
    return (
      <>
        <div
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            flex: 1,
          }}
        >
          <img
            alt="image"
            width="220px"
            height="130px"
            src={img ? img : require("../../images/noimg.png")}
            style={{
              border: 0,
              boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
              borderRadius: "10px",
              objectFit: "fill",
              fontWeight: "600",
            }}
          />
        </div>
        <div
          style={{
            ...leftContainer.parts.product_no.value_style,
            fontSize: "18px",
          }}
        >
          {text1}
        </div>
        <div
          style={{
            ...leftContainer.parts.product_name.value_style,
            fontSize: "18px",
          }}
        >
          {text2}
        </div>
        <div
          style={{
            ...leftContainer.parts.customer.value_style,
            fontSize: "18px",
          }}
        >
          {text3}
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <SessionError visible={loginError} />
      {leftContainer !== null ? (
        <Row gutter={[8, 8]} className="LeftContainer">
          <Col className="gutter-row" span={24}>
            <Row gutter={[8, 8]}>
              <Col
                className="gutter-row MainGauge"
                span={12}
                style={{ padding: "10px" }}
              >
                <div
                  style={{
                    backgroundColor: leftContainer.mainGraph.backgroundColor,
                    border: 0,
                    // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                  className="borderBox"
                >
                  <div style={{}}>
                    {console.log("m", mainG)}
                    <PerformanceGaugeGraph
                      height="140px"
                      tsize="20px"
                      graphSetting={{
                        ...leftContainer.mainGraph,
                        value: mainG,
                      }}
                      divId={"GuagePerform"}
                    />
                    {/* <GaugeGraph
                      height="150px"
                      graphSetting={leftContainer.mainGraph}
                    /> */}
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "5px",
                      marginTop: "5px",
                    }}
                  >
                    <span style={leftContainer.mainGraph.text_style}>
                      {leftContainer.mainGraph.text}
                    </span>
                  </div>
                </div>
              </Col>
              <Col className="gutter-row MicroGauge" span={12}>
                <div>
                  <Row
                    gutter={[8, 8]}
                    style={{ padding: "10px", marginTop: "-8px" }}
                  >
                    {leftContainer.microGraph.map((micro, ind) => {
                      let loc = ind + 1;
                      return (
                        <Col
                          className="gutter-row"
                          span={8}
                          key={"micro" + ind}
                        >
                          <div
                            style={{
                              backgroundColor: micro.backgroundColor,
                              border: 0,
                              // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                              boxShadow:
                                "5px 5px 9px #171717,-5px -5px 9px #232323",
                              borderRadius: "7px",
                              fontWeight: "600",
                            }}
                            className="borderBox"
                          >
                            <div>
                              <PerformanceGaugeGraph
                                height="50px"
                                graphSetting={{
                                  ...micro,
                                  value: mini["lD_MicroGauge_0" + loc],
                                }}
                                // value={micro["value"]}
                                divId={"SubGuagePerform" + ind}
                              />
                              {/* <GaugeGraph height="70px" graphSetting={micro} /> */}
                            </div>
                            <div
                              style={{
                                textAlign: "center",
                                padding: "5px",
                                marginTop: "5px",
                              }}
                            >
                              <span style={micro.text_style}>{micro.text}</span>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{ marginTop: "-15px" }}>
              <Col className="gutter-row performance" span={12}>
                <div
                  style={{
                    backgroundColor: leftContainer.performance.backgroundColor,
                    padding: "10px",
                    // height: "100%",
                    border: 0,
                    // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                  className="borderBox"
                >
                  <div className="LineContainer">
                    <div>
                      <p
                        style={{
                          ...leftContainer.performance.title.style,
                          textAlign: "center",
                        }}
                      >
                        {leftContainer.performance.title.text}
                      </p>
                    </div>
                  </div>

                  <div className="LineContainer1">
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        style={{
                          ...leftContainer.performance.target.text_style,
                          marginTop: 0,
                        }}
                      >
                        {leftContainer.performance.target.text}
                      </span>
                    </div>
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        style={{
                          ...leftContainer.performance.target.value_style,
                          fontSize: "35px",
                        }}
                      >
                        {Target}
                        {/* {leftContainer.performance.target.value} */}
                        {/* {setInterval(() => {
                          localStorage.getItem("target");
                        }, 1000)} */}
                      </span>
                    </div>
                  </div>
                  <div className="LineContainer1">
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span style={leftContainer.performance.target.text_style}>
                        {leftContainer.performance.actual.text}
                      </span>
                    </div>
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        style={{
                          ...leftContainer.performance.target.value_style,
                          fontSize: "35px",
                        }}
                      >
                        {Actual}
                        {/* {leftContainer.performance.actual.value} */}
                        {/* {setInterval(() => {
                          localStorage.getItem("actual");
                        }, 1000)} */}
                        {/* {actual} */}
                      </span>
                    </div>
                  </div>
                  <div className="LineContainer1">
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span style={leftContainer.performance.target.text_style}>
                        {leftContainer.performance.difference.text}
                      </span>
                    </div>
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        style={{
                          ...leftContainer.performance.target.value_style,
                          fontSize: "35px",
                        }}
                      >
                        {Diff}
                        {/* {leftContainer.performance.difference.value} */}
                        {/* {setInterval(() => {
                          localStorage.getItem("diff");
                        }, 1000)} */}
                        {/* {difference} */}
                      </span>
                    </div>
                  </div>
                  {/* <Divider
                    orientation="left"
                    style={{
                      color: "#3b3b3b",
                      fontWeight: "normal",
                      width: "3px",
                    }}
                  ></Divider> */}
                  <div
                    style={{
                      backgroundColor: "#212121",
                      padding: "7px",
                      marginTop: "5px",
                      boxShadow:
                        "inset 5px 5px 9px #171717,inset -5px -5px 9px #232323",
                    }}
                  >
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span style={leftContainer.performance.target.text_style}>
                        {leftContainer.performance.linerank.text}
                      </span>
                    </div>
                    <div
                      className="middleAlign"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        style={{
                          ...leftContainer.performance.target.value_style,
                          fontSize: "35px",
                        }}
                      >
                        {Rank}
                        {/* {leftContainer.performance.linerank.value} */}
                        {/* {setInterval(() => {
                          localStorage.getItem("rank");
                        }, 1000)} */}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                className="gutter-row parts"
                style={{ textAlign: "center" }}
                span={12}
              >
                <div
                  style={{
                    backgroundColor: leftContainer.parts.backgroundColor,
                    padding: "10px",
                    height: "100%",
                    border: 0,
                    // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                    borderRadius: "10px",

                    fontWeight: "600",
                  }}
                  className="borderBox"
                >
                  <div style={leftContainer.parts.title.style}>
                    {leftContainer.parts.title.text}
                  </div>
                  <ImageV />
                </div>
              </Col>
            </Row>{" "}
          </Col>{" "}
        </Row>
      ) : null}
    </React.Fragment>
  );
};
export default LineDashTabLeft;
